import * as React from 'react';
import Helmet from 'react-helmet';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const MetaTags = (props) => {
  const prop = props?.sitecoreContext?.route?.fields;
  const {
    pagetitle,
    pagedescription,
    OpenGraphTitle,
    OpenGraphDescription,
    pageimage,
    OpenGraphImageUrl,
    OpenGraphType,
    TwitterCardType,
    TwitterSite,
    TwitterTitle,
    TwitterDescription,
    TwitterImage,
    noindex,
    nofollow,
  } = prop;

  return (
    <Helmet>
      <title>{pagetitle?.value}</title>
      {pagedescription?.value && <meta name="description" content={pagedescription?.value} />}
      {pagetitle?.value && <meta property="og:title" content={OpenGraphTitle?.value === '' ? pagetitle?.value : OpenGraphTitle?.value} />}
      {pagedescription?.value && (
        <meta property="og:description" content={OpenGraphDescription?.value === '' ? pagedescription?.value : OpenGraphDescription?.value} />
      )}
      {pageimage?.value.src && (
        <meta property="og:image" content={Object.keys(OpenGraphImageUrl?.value).length === 0 ? pageimage?.value.src : OpenGraphImageUrl?.value.src} />
      )}
      <meta property="og:url" content={props?.sitecoreContext.itemUrl} />
      {OpenGraphType?.value && <meta property="og:type" content={OpenGraphType?.value} />}
      {TwitterCardType && <meta name="twitter:card" content={TwitterCardType.fields?.Value?.value} />}
      {TwitterSite?.value && <meta property="twitter:domain" content={TwitterSite?.value} />}
      {pagetitle?.value && <meta name="twitter:title" content={TwitterTitle?.value === '' ? pagetitle?.value : TwitterTitle?.value} />}
      {pagedescription?.value && (
        <meta name="twitter:description" content={TwitterDescription?.value === '' ? pagedescription?.value : TwitterDescription?.value} />
      )}
      {pageimage?.value.src && (
        <meta name="twitter:image" content={Object.keys(TwitterImage?.value).length === 0 ? pageimage?.value.src : TwitterImage?.value.src} />
      )}
      <meta name="twitter:url" content={props?.sitecoreContext.itemUrl} />
      <meta
        name="robots"
        content={
          noindex?.value && nofollow?.value
            ? 'noindex,nofollow'
            : noindex?.value && !nofollow?.value
            ? 'noindex'
            : nofollow?.value && !noindex?.value
            ? 'nofollow'
            : ''
        }
      />
      {props.sitecoreContext?.pagedata?.lastmodifieddate && <meta name="lastmodifieddate" content={props.sitecoreContext?.pagedata?.lastmodifieddate} />}
    </Helmet>
  );
};
export default withSitecoreContext()(MetaTags);
